// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"248":"3125a898","493":"e7dab9f3","536":"b49b5007","606":"7ccd5f79","838":"be82c0df","856":"f5166b38","904":"5c60e352"}[chunkId] + ".chunk.css";
};